/* eslint-disable import/no-extraneous-dependencies */
import compose from 'compose-function';
import { withRouter } from './withRouter';
import { withTmaSdk } from './withTmaSdk';
import { withToaster } from './withToaster';
import { withTonConnect } from './withTonConnect';
export const withProviders = compose(withTmaSdk, withRouter, withTonConnect, withToaster);
